function FilterIcon({ color }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='17' fill='none' viewBox='0 0 16 18'>
      <path
        fill={color}
        d='M1.5 0h13A1.5 1.5 0 0116 1.5v2.257c0 .398-.158.779-.439 1.061L10.44 9.939A1.5 1.5 0 0010 11v7l-4-3v-4c0-.398-.158-.779-.439-1.061L.441 4.818a1.501 1.501 0 01-.439-1.061V1.5C0 .672.672 0 1.5 0z'
      />
    </svg>
  );
}

export default FilterIcon;
